var _ellipse, _ellipse2, _ellipse3, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 173,
    viewBox: "0 0 182 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.5391,
    cy: 87.0795,
    rx: 78.913,
    ry: 75.0686,
    fill: "url(#paint0_radial_3_456)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.75,
    cy: 86.3288,
    rx: 90.75,
    ry: 86.3288,
    fill: "url(#paint1_radial_3_456)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.5391,
    cy: 87.8302,
    rx: 61.5522,
    ry: 57.8028,
    fill: "url(#paint2_radial_3_456)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.0234 105.623C71.9278 104.622 69.6511 104.045 67.3267 103.925C61.9602 103.677 60.9797 107.239 60.9797 107.239C56.4189 98.7334 66.4222 97.8243 66.4222 97.8243L68.1325 98.2976C71.8039 99.327 74.4415 97.4862 72.7464 97.2758C71.7355 97.1481 68.999 97.1781 66.9467 97.2157C68.8433 95.2508 71.2449 93.8327 73.8942 93.1133L45.7696 70.4301V96.855C50.5432 102.272 82.7497 129.118 82.7497 129.118L90.3509 122.949L112.189 122.438L100.521 113.858C111.452 103.625 132.006 84.285 135.487 80.3479L135.73 52.548L74.0234 105.623Z",
    fill: "#966E50"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3_456",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.5391 87.0795) rotate(90) scale(75.0686 78.913)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5CA95",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7EEE4",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3_456",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.75 86.3288) rotate(90) scale(86.3288 90.75)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8E2B8",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBF5",
    stopOpacity: 0.48
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3_456",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(91.5391 87.8302) rotate(90) scale(57.8028 61.5522)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5CA95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8EEE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3ecbc0677f833876dddd74a190c021f0.svg";
export { ForwardRef as ReactComponent };